import { Channel } from '@at/sauron-platform-core/lib/types';
export var VehicleType;
(function (VehicleType) {
    VehicleType["bike"] = "bike";
    VehicleType["car"] = "car";
    VehicleType["caravan"] = "caravan";
    VehicleType["crossover"] = "crossover";
    VehicleType["farm"] = "farm";
    VehicleType["motorhome"] = "motorhome";
    VehicleType["plant"] = "plant";
    VehicleType["truck"] = "truck";
    VehicleType["van"] = "van";
    VehicleType["cycle"] = "cycle";
})(VehicleType || (VehicleType = {}));
export var AdvertisingLocation;
(function (AdvertisingLocation) {
    AdvertisingLocation["at_bikes"] = "at_bikes";
    AdvertisingLocation["at_caravans"] = "at_caravans";
    AdvertisingLocation["at_cars"] = "at_cars";
    AdvertisingLocation["at_farm"] = "at_farm";
    AdvertisingLocation["at_lease_new_car"] = "at_lease_new_car";
    AdvertisingLocation["at_lease_virtual_car"] = "at_lease_virtual_car";
    AdvertisingLocation["at_lease_new_van"] = "at_lease_new_van";
    AdvertisingLocation["at_lease_virtual_van"] = "at_lease_virtual_van";
    AdvertisingLocation["at_motorhomes"] = "at_motorhomes";
    AdvertisingLocation["at_new_cars"] = "at_new_cars";
    AdvertisingLocation["at_new_cars_migration"] = "at_new_cars_migration";
    AdvertisingLocation["at_plants"] = "at_plants";
    AdvertisingLocation["at_profile_bikes"] = "at_profile_bikes";
    AdvertisingLocation["at_profile_caravans"] = "at_profile_caravans";
    AdvertisingLocation["at_profile_cars"] = "at_profile_cars";
    AdvertisingLocation["at_profile_motorhomes"] = "at_profile_motorhomes";
    AdvertisingLocation["at_profile_vans"] = "at_profile_vans";
    AdvertisingLocation["at_trucks"] = "at_trucks";
    AdvertisingLocation["at_vans"] = "at_vans";
    AdvertisingLocation["at_cycles"] = "at_cycles";
})(AdvertisingLocation || (AdvertisingLocation = {}));
export const cars = {
    name: Channel.cars,
    displayValue: 'Cars',
    displayValueSingle: 'Car',
    advertisingLocation: AdvertisingLocation.at_cars,
};
export const vans = {
    name: Channel.vans,
    displayValue: 'Vans',
    displayValueSingle: 'Van',
    advertisingLocation: AdvertisingLocation.at_vans,
};
export const bikes = {
    name: Channel.bikes,
    displayValue: 'Bikes',
    displayValueSingle: 'Bike',
    advertisingLocation: AdvertisingLocation.at_bikes,
};
export const motorhomes = {
    name: Channel.motorhomes,
    displayValue: 'Motorhomes',
    displayValueSingle: 'Motorhome',
    advertisingLocation: AdvertisingLocation.at_motorhomes,
};
export const caravans = {
    name: Channel.caravans,
    displayValue: 'Caravans',
    displayValueSingle: 'Caravan',
    advertisingLocation: AdvertisingLocation.at_caravans,
};
export const trucks = {
    name: Channel.trucks,
    displayValue: 'Trucks',
    displayValueSingle: 'Truck',
    advertisingLocation: AdvertisingLocation.at_trucks,
};
export const plant = {
    name: Channel.plant,
    displayValue: 'Plant machinery',
    displayValueSingle: 'Plant machinery',
    advertisingLocation: 'at_plant',
};
export const farm = {
    name: Channel.farm,
    displayValue: 'Farm machinery',
    displayValueSingle: 'Farm machinery',
    advertisingLocation: 'at_farm',
};
export const cycles = {
    name: Channel.cycles,
    displayValue: 'Electric bikes',
    displayValueSingle: 'Electric bike',
    advertisingLocation: 'at_cycles',
};
export const _channels = [cars, vans, bikes, cycles, motorhomes, caravans, trucks, plant, farm];
export const getChannelFromNameWithDefault = (channelName) => {
    const channel = _channels.find((channel) => {
        return channel.name == channelName;
    });
    return channel !== undefined ? channel : cars;
};
export const isTpf = (str) => {
    return str === 'trucks' || str === 'plant' || str === 'farm';
};
export const isLeisure = (str) => {
    return str.includes('caravan') || str.includes('motorhome');
};
export const isChannel = (str) => {
    return str === 'cars' || str === 'vans' || str === 'bikes' || str === 'motorhomes' || str === 'caravans';
};
export const isValidChannel = (channel) => {
    const channelLC = channel.toLowerCase();
    const channels = Object.entries(Channel).map(([, value]) => value.toLowerCase());
    return channels.includes(channelLC);
};
export const isAdvertisingLocation = (value) => {
    return Object.values(AdvertisingLocation).some((item) => item === value);
};
export const getChannelSingular = (channel) => channel.replace(/s$/, '');
export const getChannelCapitalised = (channel) => `${channel[0].toUpperCase()}${channel.slice(1)}`;
export const mapChannelToVehicleType = (channel) => {
    switch (channel) {
        case Channel.cars:
            return VehicleType.car;
        case Channel.vans:
            return VehicleType.van;
        case Channel.bikes:
            return VehicleType.bike;
        case Channel.cycles:
            return VehicleType.cycle;
        case Channel.caravans:
            return VehicleType.caravan;
        case Channel.motorhomes:
            return VehicleType.motorhome;
        case Channel.trucks:
            return VehicleType.truck;
        case Channel.plant:
            return VehicleType.plant;
        case Channel.farm:
            return VehicleType.farm;
        default:
            return VehicleType.car;
    }
};
export const getAdvertisingLocations = (channel) => {
    switch (channel) {
        case Channel.vans:
            return [AdvertisingLocation.at_vans];
        case Channel.bikes:
            return [AdvertisingLocation.at_bikes];
        case Channel.motorhomes:
            return [AdvertisingLocation.at_motorhomes];
        case Channel.caravans:
            return [AdvertisingLocation.at_caravans];
        case Channel.trucks:
            return [AdvertisingLocation.at_trucks];
        case Channel.plant:
            return [AdvertisingLocation.at_plants];
        case Channel.farm:
            return [AdvertisingLocation.at_farm];
        case Channel.cycles:
            return [AdvertisingLocation.at_cycles];
        case Channel.cars:
        default:
            return [AdvertisingLocation.at_cars];
    }
};
export const getSearchUrlAdvertisingLocation = (channel) => {
    switch (channel) {
        case Channel.bikes:
            return AdvertisingLocation.at_bikes;
        case Channel.caravans:
            return AdvertisingLocation.at_caravans;
        case Channel.motorhomes:
            return AdvertisingLocation.at_motorhomes;
        case Channel.vans:
            return AdvertisingLocation.at_vans;
        case Channel.trucks:
            return AdvertisingLocation.at_trucks;
        case Channel.plant:
            return AdvertisingLocation.at_plants;
        case Channel.farm:
            return AdvertisingLocation.at_farm;
        case Channel.cycles:
            return AdvertisingLocation.at_cycles;
        case Channel.cars:
        default:
            return AdvertisingLocation.at_cars;
    }
};
export const getChannelName = (advertisingLocation) => {
    switch (advertisingLocation) {
        case AdvertisingLocation.at_bikes:
        case AdvertisingLocation.at_profile_bikes:
            return Channel.bikes;
        case AdvertisingLocation.at_caravans:
        case AdvertisingLocation.at_profile_caravans:
            return Channel.caravans;
        case AdvertisingLocation.at_motorhomes:
        case AdvertisingLocation.at_profile_motorhomes:
            return Channel.motorhomes;
        case AdvertisingLocation.at_vans:
        case AdvertisingLocation.at_profile_vans:
            return Channel.vans;
        case AdvertisingLocation.at_trucks:
            return Channel.trucks;
        case AdvertisingLocation.at_plants:
            return Channel.plant;
        case AdvertisingLocation.at_farm:
            return Channel.farm;
        case AdvertisingLocation.at_cycles:
            return Channel.cycles;
        case AdvertisingLocation.at_cars:
        case AdvertisingLocation.at_profile_cars:
        default:
            return Channel.cars;
    }
};
export const getChannel = (channel) => {
    switch (channel) {
        case Channel.vans:
            return vans;
        case Channel.bikes:
            return bikes;
        case Channel.motorhomes:
            return motorhomes;
        case Channel.caravans:
            return caravans;
        case Channel.trucks:
            return trucks;
        case Channel.plant:
            return plant;
        case Channel.farm:
            return farm;
        case Channel.cars:
            return cars;
        case Channel.cycles:
            return cycles;
    }
};
